export const t25 = [
    {
      id: 0,
      name: "Gadde Madhukar Reddy",
      position: "PRESIDENT",
      alt: "/",
      image: "Team/t25/GADDE_MADHUKAR.jpg",
      socials: {
        linkedin: "https://www.linkedin.com/in/gmr-b77bb1221/",
        github: "https://github.com/GMRMADHU12",
        instagram:"https://www.instagram.com/madhukargadde/",
      },
    },
    {
      id: 1,
      name: "Gayatri Viswanadha",
      position: "VICE PRESIDENT",
      alt: "gayatri",
      image: "Team/t25/GAYATHRI_V.jpg",
      socials: {
        linkedin: "https://www.linkedin.com/in/gayathri-viswanadha-086b68270/",
        github: "https://github.com/Gayathrio4",
        instagram:"https://www.instagram.com/viswag04/?igshid=ZDdkNTZiNTM%3D",
      },
    },
    {
      id: 2,
      name: "G Sravani Reddy ",
      position: "PROMOTIONS",
      alt: "G Sravani Reddy ",
      image: "Team/t25/GOLI SRAVANI REDDY.jpg",
      socials: {
        linkedin: "https://www.linkedin.com/in/sravani-reddy-35a011223",
        github: 'https://github.com/sravanireddy24',
        instagram:'https://instagram.com/itz._.sravani_?igshid=YmMyMTA2M2Y=',
      },
    },
    {
      id: 3,
      name: "T. Karthikeya",
      position: "WEBSITE HANDLER",
      alt: "T. Karthikeya",
      image: "Team/t25/KARTHIKEYA.jpg",
      socials: {
        linkedin: "",
        github: 'https://github.com/Karthik0131',
        instagram:'https://instagram.com/ig_karthik_cr7',
      },
    },
    {
      id: 4,
      name: "M.Jayasree",
      position: "TECHNICAL",
      alt: "M.Jayasree",
      image: "Team/t25/MADDELA JAYA SREE.jpg",
      socials: {
        linkedin: "https://www.linkedin.com/in/jayasreemaddela",
        github: 'https://github.com/Jayasree326',
        instagram:'https://intsagram.com/jayasreemaddela_23',
      },
    },
    {
      id: 5,
      name: "M.Gayathri Chowdary ",
      position: "HOSPITALITY",
      alt: "M.Gayathri Chowdary ",
      image: "Team/t25/MALEMAPATI GAYAHTRI CHOWDARY.jpg",
      socials: {
        linkedin: "https://www.linkedin.com/in/gayathri-m-667a23273/",
        github: "https://github.com/Gayathri328",
        instagram:"/",
      },
    },
    {
      id: 6,
      name: "N SUNIL",
      position: "LEGALS",
      alt: "N SUNIL",
      image: "Team/t25/N P SUNIL.jpg",
      socials: {
        linkedin: "https://www.linkedin.com/in/n-sunil-8a5b81260/",
        github: "https://github.com/SunilSL",
        instagram:'https://instagram.com/sunil_nellepally?igshid=ZDdkNTZiNTM=',
      },
    },
  {
    id: 7,
    name: "Sahana",
    position: "SOCIAL MEDIA HANDLER",
    alt: "Sahana",
    image: "Team/t25/SAHANA.jpg",
    socials: {
      linkedin: "https://www.linkedin.com/in/sahana-p-44a114223",
      github: "/",
      instagram:'https://instagram.com/sahana_504?igshid=ZDdkNTZiNTM=',
    },
  },
  {
    id: 9,
    name: "Snehith",
    position: "CONTENT WRITER",
    alt: "Snehith",
    image: "Team/t25/SILVERI SNEHITH.jpg",
    socials: {
      linkedin: "https://www.linkedin.com/in/snehith-silveri-79b30222b/",
      github: "/",
      instagram:"/",
    },
  },
  {
    id: 10,
    name: "Sirisha",
    position: "LEGALS",
    alt: "Sirisha",
    image: "Team/t25/TAMMIREDDY SIRISHA.jpg",
    socials: {
      linkedin: "https://www.linkedin.com/in/tammireddy-sirisha-418895266",
      github: "/",
      instagram:'https://instagram.com/siri_2k3?igshid=ZDdkNTZiNTM=',
    },
  },
  {
    id: 11,
    name: "P Harshitha",
    position: "PROMOTIONS",
    alt: "P Harshitha",
    image: "Team/t25/HARSHITHA_P.jpg",
    socials: {
      linkedin: "/",
      github: "/",
      instagram:"/",
    },
  },
  {
    id: 12,
    name: "Sahi ram kiran",
    position: "VIDEO EDITOR",
    alt: "Sane kiran kumar reddy ",
    image: "Team/t25/ SAHI_RAM_KIRAN.jpeg",
    socials: {
      linkedin: "/",
      github: '/',
      instagram:'/',
    },
  },
  {
    id: 14,
    name: "Chakravarthy",
    position: "PHOTOGRAPHY",
    alt: "Chakri",
    image: "Team/t25/CHAKRAVARTHY.JPG",
    socials: {
      linkedin: "/",
      github: "/",
      instagram:"/",
    },
  },
  {
    id: 15,
    name: "Nuthan Kalyan",
    position: "Technical",
    alt: "/",
    image: "Team/t25/Nuthan.jpg",
    socials: {
      linkedin: "/",
      github: "/",
      instagram:"/",
    },
  },
  {
    id: 16,
    name: "Janif",
    position: "Graphic Designer",
    alt: "Janif",
    image: "Team/t25/JANIF.jpg",
    socials: {
      linkedin: "https://www.linkedin.com/in/shaik-janif-98b207264/",
      github: "/",
      instagram:"https://www.instagram.com/_janif/?igshid=ZDdkNTZiNTM%3D",
    },
  },
  {
    id: 17,
    name: "Shruthi Sai ",
    position: "TECHNICAL",
    alt: "Sai",
    image: "Team/t25/SHRUTHI_SAI.jpg",
    socials: {
      linkedin: "https://www.linkedin.com/in/keshamoni-shruthi-sai-622163256/",
      github: "https://github.com/Kshruthisai",
      instagram:"https://www.instagram.com/_nani.nani07_/?igshid=ZDdkNTZiNTM%3D",
    },
  },
  {
    id: 18,
    name: "Pravija Marlapati",
    position: "Hospitality",
    alt: "Pravija",
    image: "Team/t25/PRAVIJA_M.jpg",
    socials: {
      linkedin: "https://www.linkedin.com/in/pravija-marlapati-346b61270/",
      github: "/",
      instagram:"https://instagram.com/pravija_marlapati?igshid=ZDdkNTZiNTM=",
    },
  },
  {
    id: 19,
    name: "Sushmitha Vadagave",
    position: "Promotions",
    alt: "/",
    image: "Team/t25/sushmitha1.jpg",
    socials: {
      linkedin: "https://www.linkedin.com/in/sushmitha-vadagave-b71456256/",
      github: "https://github.com/Sushmithavadagave",
      instagram:"https://instagram.com/sush_mitha01?igshid=ZDdkNTZiNTM=",
    },
  },



  ];
  
  
  